<section class="py-md-4 py-3">
    <div class="container">
        <div class="container justify-content-center col-8 p-0">
            <div class="back-button mb-3">
                <span class="back-icon" (click)="BackToDashboard()"><i class="fa-solid fa-arrow-left"></i></span>
                <h4 class="back-button-heading mx-3">Create User</h4>
            </div>
        </div>

    </div>
    <div class="col-md-12 iframe-container">
        <iframe [src]="iframeUrlCreateUserRaw" title=""></iframe>
    </div>
</section>